module.exports = __webpack_public_path__ + "img/info-share-2.2f93228b.svg";